import React from 'react';
import { ArrowUpRight, Github } from 'lucide-react';

const Projects = () => {
  const projects = [
    {
      title: 'CIUDAD-APP',
      description: 'Full-stack mobile and web application to digitize barangay processes and services. Built with React, React Native, and Django with Shadcn and Tailwind CSS.',
      tech: ['React', 'React Native', 'Django', 'Tailwind CSS'],
      github: 'https://github.com/Aytsuu/CIUDAD-APP',
    },
    {
      title: 'Face Recognition System',
      description: 'Real-time face detection and recognition system with web-based interface for managing training datasets and performing live webcam recognition.',
      tech: ['Python', 'OpenCV', 'JavaScript', 'Node.js'],
      github: 'https://github.com/Jipy815/Face-recognition',
    },
    {
      title: 'MealPlan Creator Chatbot',
      description: 'Interactive chatbot that generates personalized meal plans using NLP. Accommodates various dietary preferences with expandable dataset architecture.',
      tech: ['Python', 'NLP', 'NLTK'],
      github: 'https://github.com/Jipy815/mealplan-creator-chatbot',
    },
  ];

  return (
    <section id="projects" className="border-y border-slate-200 bg-white px-4 py-20 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 flex flex-col justify-between gap-5 sm:flex-row sm:items-end"><div><p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-700">Selected work</p><h2 className="mt-3 text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl">Projects I’m proud of.</h2></div><a href="https://github.com/Jipy815" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-semibold text-slate-700 transition hover:text-cyan-700">View GitHub <ArrowUpRight size={17} /></a></div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group flex flex-col rounded-2xl border border-slate-200 bg-slate-50 p-7 transition duration-300 hover:-translate-y-1 hover:border-cyan-300 hover:bg-white hover:shadow-xl hover:shadow-slate-200/70"
            >
              <div className="flex h-full flex-col">
                <div className="mb-4 flex items-start justify-between gap-4">
                  <h3 className="text-xl font-bold text-slate-950">
                    {project.title}
                  </h3>
                </div>
                
                <p className="mb-6 text-sm leading-6 text-slate-600">
                  {project.description}
                </p>
                
                <div className="mb-7 flex flex-wrap gap-2">
                  {project.tech.map((tech, i) => (
                    <span
                      key={i}
                      className="rounded-full bg-cyan-100 px-3 py-1 text-xs font-semibold text-cyan-800"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                
                <div className="mt-auto flex">
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 transition hover:text-cyan-700"
                  >
                    <Github size={18} /> View code <ArrowUpRight size={16} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
